import { accountsActions, userActions } from '@modules';
import { TMiddleware } from '@modules/types';

import { checkActionsType } from './utils';
import { AccountCreateStatus } from '../modules/accounts/types';
import { IbanStatusesEnum, VerificationStatusesEnum } from '../modules/user/types';

const { available } = IbanStatusesEnum;
const { complete } = VerificationStatusesEnum;
const { success, fail } = AccountCreateStatus;

export const createAccount: TMiddleware = store => next => action => {
  const { dispatch } = store;
  const { user, accounts } = store.getState();
  const isGetUserDataAction = checkActionsType(action, [userActions.getUserData.fulfilled]);
  const isCreatedIbanActionSuccess = checkActionsType(action, [
    accountsActions.createAccount.fulfilled,
  ]);
  const isCreatedIbanActionRejected = checkActionsType(action, [
    accountsActions.createAccount.rejected,
  ]);

  const ibanStatus = user.data?.iban_status;

  if (isGetUserDataAction) {
    const userData = action.payload.data;
    const isPOAStatusComplete = userData?.checks.proof_of_address === complete;
    const isIbanAvailable = userData?.iban_status === available;

    if (
      isIbanAvailable &&
      isPOAStatusComplete &&
      ibanStatus !== IbanStatusesEnum.created &&
      accounts.loaders.createAccount === undefined
    ) {
      dispatch(accountsActions.createAccount())
        .unwrap()
        .then(() => dispatch(userActions.getUserData()))
        .catch(err => err);
    }
  }

  if (isCreatedIbanActionSuccess) dispatch(accountsActions.setAccountCreated(success));
  if (isCreatedIbanActionRejected) dispatch(accountsActions.setAccountCreated(fail));

  return next(action);
};

export default createAccount;
